import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Button, CircularProgress, Container, createStyles, Divider, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, InputLabel, makeStyles, MenuItem, Paper, Radio, RadioGroup, Select, TextField, Theme, Typography } from '@material-ui/core';
import { AuthState, createUserAsync, getSelectedUser, setSelectedUser, updateUserAsync } from '../../app/reducer/auth.reducer';

import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        radioGroup: {
            display: 'flex',
            flexDirection: 'row'
        },
        formControl: {
            width: '100%',
        },
        radioWrapped: {
            marginLeft: theme.spacing(2),
        },
        selectEmpty: {
            marginTop: theme.spacing(2),
        },
    }),
);

interface CreateProjectFormWrapperProps {
    auth: AuthState
}

interface UserInput {
    name: string,
    email: string,
    password: string,
    password_confirmation: string,
    userType: number,
    isActive: string,
    canExport: string
}

function CreateUserFormWrapper({ auth }: CreateProjectFormWrapperProps) {

    const { register, formState, getValues, setValue, handleSubmit, control, formState: { errors } } = useForm<UserInput>();
    const [busy, setBusy] = React.useState<boolean>(false);
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();

    const classes = useStyles();
    const selectedUser = useAppSelector(getSelectedUser);

    useEffect(() => {

        if (location.pathname === "/users/edit") {

            const { name, email, canExport, isActive, userType } = selectedUser;
            setValue("name", name);
            setValue("email", email);
            setValue("canExport", canExport ? "true" : "false");
            setValue("isActive", isActive ? "true" : "false");
            setValue("userType", userType);

        }

    },)

    const createUser = async (data: UserInput) => {

        const userData = {
            ...data,
            isActive: true,
            canExport: (data.canExport === "true") ? true : false
        };
        await dispatch(createUserAsync(userData));
        setBusy(false);
        history.push("/users")
    }

    const editUser = async (data: UserInput) => {
        let userData = {
            ...data,
            canExport: (data.canExport === "true") ? true : false,
            isActive: (data.isActive === "true") ? true : false
        };

        await dispatch(updateUserAsync(userData));
        setBusy(false);
        // dispatch(setSelectedUser(undefined));
        history.push("/users")
    }

    const onSubmit: SubmitHandler<UserInput> = async data => {
        setBusy(true);
        if (location.pathname === "/users/edit") {
            editUser(data);
        } else {
            createUser(data);
        }
        // await dispatch(updateUser(data));
        // console.log("PROJ", data);
        // if()
    };

    return (
        <Paper className="form-wrapper">
            <Typography variant="h5" gutterBottom>
                <b>{(location.pathname === "/users/edit") ? "EDIT USER DETAILS" : "ENTER USER DETAILS"}</b>
            </Typography>
            <Divider /><br />
            <form id="fan-details-form" onSubmit={handleSubmit(onSubmit)} style={{ padding: '5px' }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={6}>
                        <TextField
                            label="Username" disabled={(location.pathname === "/users/edit")}
                            {...register("name", { required: true })}
                            variant="outlined" fullWidth
                            error={(errors.name ? true : false)}
                            helperText={errors.name ? 'This field is required' : ''}
                        />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <TextField
                            label="Email"
                            {...register("email", { required: true })}
                            variant="outlined" fullWidth
                            error={(errors.email ? true : false)}
                            helperText={errors.email ? 'This field is required' : ''}
                        />
                    </Grid>
                    {(location.pathname === "/users/new") && <Grid item xs={12} lg={6}>
                        <TextField
                            label="Password" type="password"
                            {...register("password", { required: true })}
                            variant="outlined" fullWidth
                            error={(errors.password ? true : false)}
                            helperText={errors.password ? 'Please enter password' : ''}
                        />
                    </Grid>}
                    {(location.pathname === "/users/new") && <Grid item xs={12} lg={6}>
                        <TextField
                            label="Confirm Password" type="password"
                            {...register("password_confirmation", {
                                validate: value =>
                                    value === getValues('password') || "The passwords do not match"
                            })}
                            variant="outlined" fullWidth
                            error={(errors.password_confirmation ? true : false)}
                            helperText={errors.password_confirmation ? 'The passwords do not match' : ''}
                        />
                    </Grid>}

                    {(location.pathname === "/users/edit") && <Grid item xs={12} lg={6}>
                        <FormControl component="fieldset" error={errors.canExport ? true : false} className={classes.radioWrapped}>
                            <FormLabel component="legend">Account Active:</FormLabel>
                            <Controller
                                control={control}
                                name="isActive" rules={{ required: true }}
                                defaultValue={"false"}
                                render={({ field: { onChange, value } }) => (
                                    <RadioGroup aria-label="unit" name="isActive" value={value} onChange={onChange} className={classes.radioGroup}>
                                        <FormControlLabel value={"true"} control={<Radio />} label="Yes" />
                                        <FormControlLabel value={"false"} control={<Radio />} label="No" />
                                    </RadioGroup>
                                )}
                            />
                            <FormHelperText>{errors.userType ? 'Please specify user type' : ''}</FormHelperText>
                        </FormControl>
                    </Grid>
                    }

                    <Grid item xs={12} lg={6}>
                        <FormControl variant="outlined" className={classes.formControl} error={errors.userType ? true : false}>
                            <InputLabel>User Type</InputLabel>
                            <Controller
                                control={control}
                                name="userType" rules={{ required: true }}
                                defaultValue={2}
                                render={({ field: { onChange, value } }) => (
                                    <Select
                                        value={value}
                                        onChange={onChange}
                                        label="Encon Company Name"
                                    >
                                        <MenuItem value={1}>
                                            <em>Admin</em>
                                        </MenuItem>
                                        <MenuItem value={2}>
                                            <em>Inhouse User</em>
                                        </MenuItem>
                                        <MenuItem value={3}>
                                            <em>Agent</em>
                                        </MenuItem>
                                        <MenuItem value={4}>
                                            <em>Customer</em>
                                        </MenuItem>
                                    </Select>
                                )}
                            />
                            <FormHelperText>{errors.userType ? 'This field is required' : ''}</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <FormControl component="fieldset" error={errors.canExport ? true : false} className={classes.radioWrapped}>
                            <FormLabel component="legend">Can Export Datasheet</FormLabel>
                            <Controller
                                control={control}
                                name="canExport" rules={{ required: true }}
                                defaultValue={"false"}
                                render={({ field: { onChange, value } }) => (
                                    <RadioGroup aria-label="unit" name="canExport" value={value} onChange={onChange} className={classes.radioGroup}>
                                        <FormControlLabel value={"true"} control={<Radio />} label="Yes" />
                                        <FormControlLabel value={"false"} control={<Radio />} label="No" />
                                    </RadioGroup>
                                )}
                            />
                            <FormHelperText>{errors.userType ? 'Please specify user type' : ''}</FormHelperText>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                   <Grid item xs={12} lg={12}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            size="large"
                            style={{ marginLeft: '20px', backgroundColor: '#10B981' }}
                            disabled={busy}
                        >
                            {busy ? <CircularProgress size={26} /> : "Save"}
                        </Button>

                        <Button
                            variant="outlined"
                            size="large"
                            style={{backgroundColor:'red', color:'white', marginLeft: '10px' }}
                            onClick={() => history.push("/users")}
                            
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Paper>
    );
}


interface IRootState {
    auth: AuthState
}

export class EditUser extends React.Component<IRootState, {}> {

    render() {
        const { auth } = this.props;

        return (
            <div className="page-wrapper">
                <Container maxWidth="xl">
                    <CreateUserFormWrapper auth={auth} />
                </Container>
            </div>
        );
    }

}

const mapStateToProps = (state: IRootState, ownProps = {}) => ({
    auth: state.auth
});

export default connect(mapStateToProps)(EditUser)